import { ActionTypes } from "./actions";

export const initialState = {
  countries: [],
  currencies: [],
};

export default (state = initialState, action) => {
  switch (action.type) {
    case ActionTypes.FETCH_COUNTRIES.SUCCESS: {
      return {
        ...state,
        countries: action.payload.data,
      };
    }
    case ActionTypes.FETCH_CURRENCY.SUCCESS: {
      return {
        ...state,
        currencies: action.payload.data,
      };
    }
    default:
      return state;
  }
};
